import { useEffect } from 'react';

/**
 * Pending websocket implementation
 */
const Websocket = ({ children }) => {
  useEffect(() => {

  }, []);

  return children;
}

export default Websocket;
